import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isMobile, openAppOrStore, tryOpenApp } from '../utils/deviceDetection'

const STORE_PATHS = ['/episodes/', '/series/', '/search/']
const STORE_EXACT = ['/schedule']
const APP_ONLY_PATHS = ['/recover-password/']
const SESSION_KEY = 'cosmo_redirect_attempted'

const MobileRedirect = () => {
  const location = useLocation()

  useEffect(() => {
    if (!isMobile()) return
    if (sessionStorage.getItem(SESSION_KEY)) return

    const { pathname } = location
    const isStorePath =
      STORE_EXACT.includes(pathname) ||
      STORE_PATHS.some((p) => pathname.startsWith(p))
    const isAppOnlyPath = APP_ONLY_PATHS.some((p) => pathname.startsWith(p))

    if (!isStorePath && !isAppOnlyPath) return

    sessionStorage.setItem(SESSION_KEY, '1')

    if (isAppOnlyPath) {
      tryOpenApp(pathname)
    } else {
      openAppOrStore(pathname)
    }
  }, [location.pathname])

  return null
}

export default MobileRedirect
